/* DAILE v2 (dv) — DAILE Journal behaviour.
 * - dv-journal-tags  (sections/dv-journal-blog.liquid): "More topics" toggle
 *   (aria-expanded, label swap) and, on phones, scrolls the one-row topic
 *   list so the current topic is visible.
 * - dv-journal-share (sections/dv-journal-article.liquid): "Copy link"
 *   (Clipboard API with a textarea fallback, DV.toast confirmation) and the
 *   system share sheet via navigator.share, shown only where supported.
 * No third-party scripts. Every listener is removed in destroy (theme editor).
 */
(() => {
  'use strict';
  if (!window.DV) return;

  DV.register('dv-journal-tags', (root) => {
    const nav = DV.queryAll(root, '[data-dv-journal-tags]')[0];
    if (!nav) return undefined;

    const toggle = nav.querySelector('[data-dv-journal-tags-toggle]');
    const more = nav.querySelector('[data-dv-journal-tags-more]');
    const less = nav.querySelector('[data-dv-journal-tags-less]');
    const list = nav.querySelector('.dv-journal-tags__list');

    const onToggle = () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-expanded', open);
      if (more) more.hidden = open;
      if (less) less.hidden = !open;
    };
    if (toggle) toggle.addEventListener('click', onToggle);

    // One-row scroller on phones: bring the current topic into view without
    // moving the page vertically.
    const current = list && list.querySelector('[aria-current="page"]');
    if (list && current && list.scrollWidth > list.clientWidth + 1) {
      const listBox = list.getBoundingClientRect();
      const box = current.getBoundingClientRect();
      if (box.left < listBox.left || box.right > listBox.right) {
        const delta = box.left + box.width / 2 - (listBox.left + listBox.width / 2);
        list.scrollLeft += delta;
      }
    }

    return () => {
      if (toggle) toggle.removeEventListener('click', onToggle);
    };
  });

  DV.register('dv-journal-share', (root) => {
    const box = DV.queryAll(root, '[data-dv-journal-share]')[0];
    if (!box) return undefined;

    const copyButton = box.querySelector('[data-dv-journal-copy]');
    const nativeItem = box.querySelector('[data-dv-journal-native]');
    const nativeButton = box.querySelector('[data-dv-journal-native-share]');

    const fallbackCopy = (text) => {
      const area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.insetBlockStart = '-1000px';
      area.style.opacity = '0';
      document.body.append(area);
      area.select();
      let ok = false;
      try { ok = document.execCommand('copy'); } catch (error) { ok = false; }
      area.remove();
      return ok;
    };

    const onCopy = () => {
      const url = copyButton.getAttribute('data-dv-journal-copy') || window.location.href;
      const message = copyButton.getAttribute('data-dv-journal-copied') || 'Link copied';
      const done = () => DV.toast(message);
      // Clipboard blocked (permissions, embedded browser): still show the reader the link.
      const failed = () => DV.toast(url, { timeout: 7000 });
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(done, () => { if (fallbackCopy(url)) done(); else failed(); });
      } else if (fallbackCopy(url)) {
        done();
      } else {
        failed();
      }
    };

    const onShare = () => {
      const url = nativeButton.getAttribute('data-dv-journal-native-share') || window.location.href;
      const title = nativeButton.getAttribute('data-dv-journal-title') || document.title;
      navigator.share({ title, url }).catch(() => { /* dismissed by the reader */ });
    };

    if (copyButton) copyButton.addEventListener('click', onCopy);
    if (nativeItem && nativeButton && typeof navigator.share === 'function') {
      nativeItem.hidden = false;
      nativeButton.addEventListener('click', onShare);
    }

    return () => {
      if (copyButton) copyButton.removeEventListener('click', onCopy);
      if (nativeButton) nativeButton.removeEventListener('click', onShare);
    };
  });
})();
